import { newFaceImgList } from './utils';

const renderEmoji = html => {
    let formatedHtml = html;

    if (formatedHtml && html) {
        newFaceImgList.forEach((item, index) => {
            // eslint-disable-next-line no-useless-escape
            const reg = `\\[${item.name}\\]`;

            const regExp = new RegExp(reg, 'g');

            let imgUrl = '';

            if (regExp.test(html)) {
                const indexStr = String(index + 1);

                const imgName = indexStr.length < 2 ? `00${index + 1}.png` : `0${index + 1}.png`;

                imgUrl = require(`../icons/${imgName}`);

                formatedHtml = formatedHtml.replace(regExp, `<image src="${imgUrl}" />`);
            }
        });
    }

    return formatedHtml;
};

export default renderEmoji;
